import { Box, Link } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const TitleLine = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
}));

export const Card = styled(Link)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  textDecoration: "none",
  gap: theme.spacing(1.5),
  width: "100%",
  height: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  padding: theme.spacing(1.5, 2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "transparent",
  border: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create(["border-color", "box-shadow"], {
    duration: theme.transitions.duration.shorter,
  }),
  "&:hover": {
    borderColor: theme.palette.secondary.main,
    boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.08)}`,
  },

  [theme.breakpoints.down(910)]: {
    padding: theme.spacing(0.5),
    gap: theme.spacing(0.5),
  },

  [theme.breakpoints.down(600)]: {
    maxWidth: "210px",
  },

  [theme.breakpoints.down(1250)]: {
    maxWidth: "none",
  },

  [theme.breakpoints.down("md")]: {
    justifyContent: "flex-start",
    flex: "1 1 0",
    width: "100%",
    minWidth: 0,
    maxWidth: "none",
    padding: theme.spacing(2),
    gap: theme.spacing(1.25),
    backgroundColor: theme.palette.background.paper,
  },

  [theme.breakpoints.down(575)]: {
    padding: theme.spacing(2, 1.75),
    gap: theme.spacing(1),
    width: "100%",

    "& br": {
      display: "none",
    },
  },
}));
